import { useState, useEffect, useCallback } from 'react';
import { getAllTeamMembers, addNewMember } from '~/services/team';

const useTeamMembers = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getAllTeamMembers()
      .then(setMembers)
      .catch((error) => setError(error.message))
      .then(() => setLoading(false));
  }, []);

  return { members, loading, error };
};

export default useTeamMembers;
